export const BRAND = {
  name: "Equipment Concierge",
  domain: "equipmentconcierge.com",
  phone: "305-582-5282",
  phoneHref: "tel:+13055825282",
  waHref: "https://wa.me/13055825282",
  email: "info@equipmentlivechat.com",
  emailHref: "mailto:info@equipmentlivechat.com",
};

export { IMAGES } from "./media";

export const COPY = {
  en: {
    meta: "Tractor, golf cart, UTV, mower, horse trailer and RV service for horse farms in Wellington, Loxahatchee, Jupiter Farms and all of Palm Beach County, FL. One call to 305-582-5282.",
    nico: "Just call Nico.",
    nav: {
      services: "Services",
      how: "How it works",
      equipment: "Equipment",
      area: "Service area",
      callShort: "Call",
    },
    hero: {
      eyebrow: "Equipment Concierge — Wellington, Florida",
      title1: "Your farm's equipment,",
      title2: "fully handled.",
      sub: "We inspect, repair, sell, replace and deliver — tractors, golf carts, UTVs, mowers, trailers and RVs. One call.",
      call: "Call 305-582-5282",
      wa: "WhatsApp",
      trust: "Serving Wellington · Loxahatchee · Jupiter Farms & all of Palm Beach County",
      scroll: "Scroll",
    },
    marquee: [
      "Tractors",
      "Golf Carts",
      "UTVs",
      "Zero-Turn Mowers",
      "Arena Drags",
      "Horse Trailers",
      "RVs",
    ],
    problem: {
      eyebrow: "The problem",
      lines: ["Fix it?", "Sell it?", "Replace it?"],
      lead: "You don't have time for mechanics, Marketplace and back-and-forth.",
      body: "Every tractor that won't start, every golf cart that stalls and every trailer that sits unused is one more thing on your list. Equipment Concierge takes the whole problem off your hands — we come to your farm, sort every unit and keep your barn moving.",
      chips: ["One call", "We come to you", "Everything handled"],
    },
    services: {
      eyebrow: "What we do",
      title: "One call. Everything handled.",
      sub: "From a dead golf cart to a whole fleet refresh — we take the equipment off your desk so your barn keeps moving.",
      quote: "Call for a quote",
      items: [
        {
          title: "Evaluate every unit",
          desc: "A clear verdict for every machine on the farm — keep, fix, sell or replace.",
        },
        {
          title: "On-farm repairs",
          desc: "Hydraulics, batteries, engines and electrical — fixed where the machine sits.",
        },
        {
          title: "Sell what you don't use",
          desc: "Cleaned up, sold, cash back to you — with clear, honest commission.",
        },
        {
          title: "Source & deliver",
          desc: "The right replacement, found and delivered to your barn, ready to work.",
        },
        {
          title: "Horse-trailer road-ready checks",
          desc: "Lights, brakes, fans, tires, hitch and electrical — ready before the next haul.",
        },
        {
          title: "Golf cart refresh & repair",
          desc: "Batteries, chargers, brakes and cosmetics — barn-ready again.",
        },
        {
          title: "RVs for groom housing",
          desc: "Chosen, delivered and installed — comfortable housing for your team.",
        },
        {
          title: "Mini loader rental",
          desc: "By the day or with an operator. Call for a quote.",
        },
      ],
    },
    how: {
      eyebrow: "How it works",
      title: "Three steps. Zero hassle.",
      hotline: "One number does it all.",
      steps: [
        {
          title: "Call or WhatsApp us",
          desc: "Tell us what's acting up — or just say \"handle my equipment.\"",
        },
        {
          title: "We come to your farm and assess",
          desc: "We walk the property with you and evaluate every unit.",
        },
        {
          title: "We handle it all",
          desc: "Repairs, sales, sourcing, delivery — done. Your barn keeps moving.",
        },
      ],
    },
    gallery: {
      eyebrow: "Equipment we handle",
      title: "Real Farms. Real Results.",
      sub: "Equipment we've sold, repaired and delivered for happy customers across Palm Beach County.",
      quote: "Call for a quote",
      quoteTitle: "Need something else?",
      items: [
        { name: "Tractors" },
        { name: "Golf Carts" },
        { name: "UTVs" },
        { name: "Zero-Turn & Riding Mowers" },
        { name: "Arena Drags" },
        { name: "Horse Trailers" },
        { name: "RVs" },
      ],
    },
    area: {
      eyebrow: "Service area",
      title: "We come to your farm.",
      lead: "Based in the heart of horse country, we cover the equestrian community across South Florida.",
      areas: [
        "Wellington",
        "Loxahatchee",
        "Jupiter Farms",
        "All of Palm Beach County",
        "Parts of Martin County",
        "Parts of Okeechobee County",
        "Western Broward County",
      ],
      note: "Not sure if you're in range? Call us — we're flexible.",
    },
    cta: {
      tagline: "Yes. Do it all. Just call us.",
      sub: "One call and your equipment is our problem — not yours.",
      call: "Call 305-582-5282",
      wa: "WhatsApp",
      email: "Email us",
    },
    bar: { call: "Call 305-582-5282", wa: "WhatsApp" },
    footer: {
      tagline: "Yes. Do it all. Just call us.",
      contact: "Contact",
      area: "Service area",
      areaLine:
        "Wellington, Loxahatchee, Jupiter Farms & all of Palm Beach County — plus parts of Martin, Okeechobee and western Broward.",
      rights: "All rights reserved.",
    },
  },
  es: {
    meta: "Servicio de tractores, carritos de golf, UTVs, cortadoras, trailers y RVs para fincas en Wellington, Loxahatchee, Jupiter Farms y todo el Condado de Palm Beach. Una llamada al 305-582-5282.",
    nico: "Solo llame a Nico.",
    nav: {
      services: "Servicios",
      how: "Cómo funciona",
      equipment: "Equipo",
      area: "Zona de servicio",
      callShort: "Llamar",
    },
    hero: {
      eyebrow: "Equipment Concierge — Wellington, Florida",
      title1: "El equipo de su finca,",
      title2: "totalmente resuelto.",
      sub: "Inspeccionamos, reparamos, vendemos, reemplazamos y entregamos — tractores, carritos de golf, UTVs, cortadoras, trailers y RVs. Una llamada.",
      call: "Llamar 305-582-5282",
      wa: "WhatsApp",
      trust: "Wellington · Loxahatchee · Jupiter Farms y todo el Condado de Palm Beach",
      scroll: "Desliza",
    },
    marquee: [
      "Tractores",
      "Carritos de Golf",
      "UTVs",
      "Cortadoras",
      "Rastrillos de Arena",
      "Trailers",
      "RVs",
    ],
    problem: {
      eyebrow: "El problema",
      lines: ["¿Arreglarlo?", "¿Venderlo?", "¿Reemplazarlo?"],
      lead: "No tiene tiempo para mecánicos, Marketplace y idas y vueltas.",
      body: "Cada tractor que no arranca, cada carrito que se detiene y cada trailer sin usar es un pendiente más en su lista. Equipment Concierge se encarga del problema completo: vamos a su finca, evaluamos cada unidad y su caballeriza sigue moviéndose.",
      chips: ["Una llamada", "Vamos a usted", "Todo resuelto"],
    },
    services: {
      eyebrow: "Qué hacemos",
      title: "Una llamada. Todo resuelto.",
      sub: "Desde un carrito sin batería hasta renovar toda su flota: nosotros nos encargamos del equipo para que su caballeriza siga moviéndose.",
      quote: "Llame para cotizar",
      items: [
        {
          title: "Evaluamos cada unidad",
          desc: "Un veredicto claro para cada máquina de la finca: conservar, reparar, vender o reemplazar.",
        },
        {
          title: "Reparaciones en la finca",
          desc: "Hidráulica, baterías, motores y electricidad: reparados donde está la máquina.",
        },
        {
          title: "Vendemos lo que no usa",
          desc: "Limpieza, venta y efectivo para usted, con una comisión clara y honesta.",
        },
        {
          title: "Buscamos y entregamos",
          desc: "El reemplazo correcto, encontrado y entregado en su caballeriza, listo para trabajar.",
        },
        {
          title: "Trailers listos para la ruta",
          desc: "Luces, frenos, ventiladores, llantas, enganche y electricidad: listos antes del próximo viaje.",
        },
        {
          title: "Carritos de golf renovados",
          desc: "Baterías, cargadores, frenos y estética: listos para la caballeriza.",
        },
        {
          title: "RVs para sus trabajadores",
          desc: "Elegidos, entregados e instalados: alojamiento cómodo para su equipo.",
        },
        {
          title: "Renta de mini cargadora",
          desc: "Por día o con operador. Llame para cotizar.",
        },
      ],
    },
    how: {
      eyebrow: "Cómo funciona",
      title: "Tres pasos. Cero complicaciones.",
      hotline: "Un solo número lo resuelve todo.",
      steps: [
        {
          title: "Llámenos o escríbanos por WhatsApp",
          desc: "Cuéntenos qué necesita — o solo diga: \"ocúpese de mi equipo\".",
        },
        {
          title: "Vamos a su finca y evaluamos",
          desc: "Recorremos la propiedad con usted y evaluamos cada unidad.",
        },
        {
          title: "Nosotros lo resolvemos todo",
          desc: "Reparaciones, ventas, gestión y entrega: listo. Su caballeriza sigue moviéndose.",
        },
      ],
    },
    gallery: {
      eyebrow: "Equipo que atendemos",
      title: "Fincas reales. Resultados reales.",
      sub: "Equipos que hemos vendido, reparado y entregado para clientes felices en todo el Condado de Palm Beach.",
      quote: "Llame para cotizar",
      quoteTitle: "¿Necesita otra cosa?",
      items: [
        { name: "Tractores" },
        { name: "Carritos de Golf" },
        { name: "UTVs" },
        { name: "Cortadoras de Asiento" },
        { name: "Rastrillos de Arena" },
        { name: "Trailers de Caballos" },
        { name: "RVs" },
      ],
    },
    area: {
      eyebrow: "Zona de servicio",
      title: "Vamos a su finca.",
      lead: "Desde el corazón del país del caballo, cubrimos la comunidad ecuestre del sur de la Florida.",
      areas: [
        "Wellington",
        "Loxahatchee",
        "Jupiter Farms",
        "Todo el Condado de Palm Beach",
        "Partes del Condado de Martin",
        "Partes del Condado de Okeechobee",
        "Oeste del Condado de Broward",
      ],
      note: "¿No está seguro si estamos a su alcance? Llámenos — llegamos.",
    },
    cta: {
      tagline: "Sí. Hacemos todo. Solo llámenos.",
      sub: "Una llamada y su equipo es problema nuestro — no suyo.",
      call: "Llamar 305-582-5282",
      wa: "WhatsApp",
      email: "Escríbanos",
    },
    bar: { call: "Llamar 305-582-5282", wa: "WhatsApp" },
    footer: {
      tagline: "Sí. Hacemos todo. Solo llámenos.",
      contact: "Contacto",
      area: "Zona de servicio",
      areaLine:
        "Wellington, Loxahatchee, Jupiter Farms y todo el Condado de Palm Beach — además de partes de Martin, Okeechobee y el oeste de Broward.",
      rights: "Todos los derechos reservados.",
    },
  },
};
